<section class="bg-gradient container border pb-5 mb-28">
  <h1 class="ml-5 pt-5 pb-5 strong text-white text-shadow font-italic">Exclusão de Responsabilidade</h1>
  <div class="row pl-3">
    <div class="col-md-12 sup">
      <img src="../../assets/images/logo/faria.png" class="img-fluid logo-tc" />
    </div>
  </div>
  <div class="row d-flex justify-content-center -mt-5">
    <div class="col-md-10">
      <div class="mb-5 jumbotron">
        <p class="text-justify">
          A Relojoaria Faria não pode ser responsabilizada por todos os assuntos relacionados com: 
        </p>
        <ul class="list-group list-group-flush p-3">
          <li class="list-group-item">
            <fa-icon [icon]="faCheck" class="fal fa-check mr-2 text-yellow"></fa-icon>
            ofertas de emprego ou propostas profissionais enviadas por e-mail sem o seu consentimento explícito ou oferecidas através de websites que não são acessíveis através do selector no topo desta página;
          </li>
          <li class="list-group-item">
            <fa-icon [icon]="faCheck" class="fal fa-check mr-2 text-yellow"></fa-icon>
            encomendas ou solicitações comerciais enviadas por e-mail ou oferecidas através de websites que não são acessíveis através do selector no topo desta página. 
          </li>
        </ul>
        <p class="text-justify">
          Qualquer encomenda ou solicitação comercial proveniente da empresa Relojoaria Faria deve ser acompanhada com os departamentos apropriados e interlocutores claramente identificados. 
        </p>
      </div>
    </div>
  </div>
</section>
